// NOTE!! Be sure to all this higher in the DOM than the components you want in front of the rain

import { FC, useMemo, useState, useEffect, PropsWithChildren } from "react"
import tw from "tailwind-styled-components"

const MakeItRainContainer = tw.div`
  color: #fff;
  font-family: Arial, sans-serif;
  text-shadow: 0 0 5px #000;
`

const MakeItRainDrop = tw.div`text-xl`

const _times = function (
  n: number,
  iterator: (i: number) => React.ReactElement
): React.ReactElement[] {
  var accum = Array(Math.max(0, n))
  for (var i = 0; i < n; i++) accum[i] = iterator(i)
  return accum
}
const moneyEmojis = [
  "💰",
  "💸",
  "💵",
  "💶",
  "💷",
  "🤑",
  "💳",
  "💴",
  "💲",
  "💱",
  "💹",
  "🏦",
  "🏧",
  "💲",
  "💰",
  "💸",
  "💵",
  "💶",
  "💷",
  "🤑",
  "💳",
]

const MakeItRain: FC<PropsWithChildren<{}>> = () => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])

  const renderedElements = useMemo(() => {
    if (mounted) {
      return _times(12, (i) => {
        const fontSize = Math.floor(Math.random() * 3 + 2)
        return (
          <MakeItRainDrop
            key={`rain-drop-${i}`}
            style={{
              fontSize: `${fontSize}rem`,
              filter: `blur(10px)`,
            }}
            className="makeItRainDrop"
          >
            {moneyEmojis[Math.floor(Math.random() * moneyEmojis.length)]}
          </MakeItRainDrop>
        )
      })
    }
  }, [mounted])

  return (
    <>
      <MakeItRainContainer className={`z-0`} aria-hidden="true">
        {renderedElements}
      </MakeItRainContainer>
    </>
  )
}

export default MakeItRain
